// extracted by mini-css-extract-plugin
module.exports = {"product-card-grid-loader-wrapper":"product-card-loader_product-card-grid-loader-wrapper__27IBd","products-cards":"product-card-loader_products-cards__KIkb_"};